module.exports = __webpack_public_path__ + "static/media/black.57ace714.jpg";